import React, { Component } from "react"
import { Table, Row, Input, message, Select, Icon, Button,Col } from "antd"
import { observable,toJS } from "mobx"
import { observer, inject } from "mobx-react"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import cx from "classnames"
import styled from 'styled-components'
import { disposeFileSize } from "app/vendor/util"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import FlexableFileName from "app/components/normal/FlexableFileName"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import getPathogen from "app/utils/pathogenDispose"
import { debounce } from "../../../../vendor/util"
import deleteAbleIcon from "app/styles/images/sp/delete.svg"
import TRANINFOS_MAP from "./TraninfosMap"
import { TRANINFOS_OPTION,  TRANINFO_DEFAULT_OBJECT ,
  Range_OPTION,Range_TRANINFO_DEFAULT_OBJECT} from '../../../../utils/const'

const Option = Select.Option
const OperateBtnWrapper = styled.div`
  display: flex;
  margin-left: 10px;
  .anticon-minus-circle {
    font-size: 14px;
    cursor: pointer;
  }
  .anticon-plus-circle {
    color: #286cac;
    font-size: 14px;
    cursor: pointer;
  }
`

const ObserverMutationsSelector = observer(({
  value,
  field,
  totalMutations,
  onChange,
}) => {
  const filterOption = (inputValue, option) =>{
    return option.key.search(new RegExp(inputValue, "i")) > -1
  }
  return (
    <div className='ta-c'>
      <Select
        multiple
        tags
        style={{ width: 200 }}
        placeholder="请选择突变后运行"
        value={value}
        filterOption={filterOption}
        onChange={onChange}
      >
       {totalMutations.slice().map((mutation) => (
        <Option key={mutation}>{mutation}</Option>
      ))}
      </Select>
    </div >
  )
})

const ObserverRelationSelector = observer(({ record, relations, onChange }) => {
  return (
    <div className="ta-c relation-helper-wrapper">
      {record.marked && (
        <span
          className="relation-helper"
          style={{ background: record.color }}
        />
      )}
      <Select
        style={{ width: "75%" }}
        placeholder="请选择关系"
        value={record.relationName}
        onChange={onChange}
      >
        {relations.slice().map((relation) => (
          <Option key={relation.id}>{relation.name}</Option>
        ))}
      </Select>
    </div>
  )
})

const ObserverPathogenSelector = observer(({ record, onChange }) => {
  const pathogenList = getPathogen(record.relationName)
  let keys = []
  let values = []

  if (pathogenList) {
    keys = [...pathogenList.keys()]
    values = [...pathogenList.values()]
  }

  return (
    <div className="ta-c relation-helper-wrapper">
      <Select
        style={{ width: "90%" }}
        placeholder="请选择致病性"
        value={record.pathogen || undefined}
        onChange={onChange}
      >
        {keys.map((key, index) => (
          <Option key={key}>{values[index]}</Option>
        ))}
      </Select>
    </div>
  )
})

const ObserverInput = observer(({ record, field, onChange, placeholder }) => {
  return (
    <div className="ta-c">
      <Input
        style={{ width: "95%" }}
        value={record[field]}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  )
})

const ObserverSampleName = observer(
  ({ record, editHistoryList, onChange, onVisibleChange }) => {
    const sampleNameEllipsis = (
      <MaterialTip overlayClassName="ellipsis-tip" title={record.sampleName}>
        <div className="sample-name ellipsis cursor-p">{record.sampleName}</div>
      </MaterialTip>
    )

    return record.hasHistory ?
      (<Row className="cursor-p" type="flex" justify="center" align="middle">
        <WarningTip
          type="warningTip"
          text={sampleNameEllipsis}
          justify="start"
          mainKeys={["versionNum", "sampleName", "createTime"]}
          overlayClassName="ta-c"
          historyData={editHistoryList}
          onVisibleChange={onVisibleChange}
        />
      </Row>) :
      record.hasName ?
        (<div className="ta-c">{sampleNameEllipsis}</div>) :
        (<ObserverInput
          record={record}
          field="sampleName"
          onChange={onChange}
          placeholder="请手动填写样本名"
        />)
  }
)
const Observerremark = observer(({ record, onChange }) => {
  return record.hasRemark ?
    // <MaterialTip title={record.remark}>
    //   <div className="ellipsis ta-c">{record.remark}</div>
    // </MaterialTip> :
    <ObserverInput
      record={record}
      field="remark"
      value={record.remark}
      onChange={onChange}
    />
    :
    <ObserverInput
      record={record}
      field="remark"
      placeholder="请填写备注"
      onChange={onChange}
    />
})
const ObserverPatientName = observer(({ record, onChange }) => {
  return record.hasPatientName ?
    // <MaterialTip title={record.patientName}>
    //   <div className="ellipsis ta-c">{record.patientName}</div>
    // </MaterialTip> 
    <ObserverInput
      record={record}
      field="patientName"
      value={record.patientName}
      onChange={onChange}
    />
    :
    <ObserverInput
      record={record}
      field="patientName"
      placeholder="请填写样本姓名"
      onChange={onChange}
    />
})

const ObserverOperator = observer(({ record, onClick }) => {
  //let editIcon, editTitle

  // [editIcon, editTitle] = record.hasName || record.hasRemark  // 如果需要判断禁用，解除掉注释并修改src为editIcon、title为editTitle
  //   ? [editAbleIcon, "修改"]
  //   : [editDisableIcon, "请先填写并保存样本名"]
  return (
    <Row
      className="table-oprator"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <img
        className={cx({
          disable: !record.hasName && !record.hasRemark && !record.hasPatientName,
          "cursor-p": true,
        })}
        title="修改"
        src={editAbleIcon}
        alt=""
        onClick={() => onClick({ record, type: "edit" })}
      />
      <img
        title="删除"
        src={deleteAbleIcon}
        alt=""
        onClick={() => onClick({ record, type: "delete" })}
      />
    </Row>
  )
})

@inject("pgdDataManageDetail")
@observer
export default class extends Component {
  state = {
    showDeleteModal: false,
    showEditModal: false,
    focusedSample: {},
    editedHistory: [],
    syncBtnLoading: false,
  }

  componentDidMount() {
    const { pgdDataManageDetail } = this.props
    pgdDataManageDetail.getSamplesRefrenceData()
    pgdDataManageDetail.initTableData().then(
      () => {
        pgdDataManageDetail.loadPrimers()
        pgdDataManageDetail.loadRelations()
        pgdDataManageDetail.loadGenes()
      },
      (err) => {
        message.error(err.message)
      }
    )
  }

  showOperateModal = ({ record, type }) => {
    // if (!record.hasName) {    // 现在不需要判断是否禁用了，如果需要解除掉注释即可
    //   return
    // }

    if (type === "delete") {
      this.showDeleteModal(record)
    } else {
      this.showEditModal(record)
    }
  }

  showDeleteModal = (record) => {
    this.setState({
      showDeleteModal: true,
      focusedSample: record,
    })
  }

  showEditModal = (record) => {
    this.currentSampleName = record.sampleName

    this.setState({
      showEditModal: true,
      focusedSample: record,
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false,
    })
  }

  onSelectChange = (selectedRowKeys) => {
    this.props.pgdDataManageDetail.selectedRowKeys = selectedRowKeys
  }

  toggleHistory = (visible, record) => {
    const { loadEditHistory, clearEditHistory } = this.props.pgdDataManageDetail
    if (visible) {
      loadEditHistory(record.dataId)
    } else {
      clearEditHistory()
    }
  }

  @debounce()
  parseCSV = () => {
    const { parseCSV } = this.props.pgdDataManageDetail
    parseCSV(this.csvInput.refs.input.value)
      .then(() => {
        message.success("解析成功")
        this.csvInput.refs.input.value = ""
      })
      .catch((err) => {
        message.error(err.message)
        return Promise.reject(err)
      })
  }

  deleteSample = (sampleId) => {
    const {
      pgdDataManageDetail: { deleteSample, deleteData },
    } = this.props
    deleteSample(sampleId).then(
      (res) => {
        this.setState({
          showDeleteModal: false,
        })
        deleteData(sampleId)
        message.success("数据删除成功")
      },
      (err) => {
        message.error(err.message)
      }
    )
  }

  operatorItem = (idx, arr) => {
    const { structureMut, setEdited } = this.props.pgdDataManageDetail
   
    if (idx === arr.length - 1) {
      structureMut.push(TRANINFO_DEFAULT_OBJECT)
    } else {
      structureMut.splice(idx, 1)
    }
    setEdited()
  }
  delRangeOperatorItem= (idx, arr) => {
    const { delRange, setEdited } = this.props.pgdDataManageDetail
   
    if (idx === arr.length - 1) {
      delRange.push(Range_TRANINFO_DEFAULT_OBJECT)
    } else {
      delRange.splice(idx, 1)
    }
    setEdited()
  }
  handleSyncSampleInfo = () => {
    const {
      syncSampleInfo,
      getSamplesRefrenceData,
    } = this.props.pgdDataManageDetail
    this.setState({ syncBtnLoading: true })
    syncSampleInfo().then(
      (res) => {
        message.success("同步成功")
        getSamplesRefrenceData()
        this.setState({ syncBtnLoading: false })
      },
      (err) => {
        this.setState({ syncBtnLoading: false })
        message.error(err.message)
      }
    )
  }

  render() {
    const { focusedSample, showEditModal } = this.state
    const {
      sampleData,
      sampleData:{
        pgdDataDTOs
      },
      onGenesSelect,
      samplesData,
      selectedRowKeys,
      totalPrimers,
      totalGenes,
      totalMutations,
      familyInfo,
      onPrimerSelect,
      onRelationChange,
      onSampleNameChange,
      onMutationsSelect,
      editHistoryList,
      relations,
      onPathogenChange,
      structureMut,
      delRange,
      onTraninfoChange,
      delRangeOnTraninfoChange,
      handleTraninfoObj,
    } = this.props.pgdDataManageDetail

    this.columns = [
      {
        title: <div className="ta-l">文件名称</div>,
        dataIndex: "filename",
        width: 145,
        render: (filename, record, index) => {
          return (
            <FlexableFileName
              wordWrap={true}
              filename={filename}
              matched={record.matched}
            />
          )
        },
      },
      {
        title: <div className="ta-c">样本编号/条码</div>,
        dataIndex: "sampleName",
        width: 80,
        render: (sampleName, sample, index) => {
          return (
            <ObserverSampleName
              record={sample}
              editHistoryList={editHistoryList}
              onChange={(e) => onSampleNameChange(e.target.value, sample)}
              onVisibleChange={(visible) => this.toggleHistory(visible, sample)}
            />
          )
        },
      },
      {
        title: <div className="ta-c">样本姓名</div>,
        dataInde: "patientName",
        width: 70,
        render: (text, record) => {
          const { onInputChangePatientName } = this.props.pgdDataManageDetail
          return (
            <ObserverPatientName
              record={record}
              onChange={(e) => onInputChangePatientName(e.target.value, record, "patientName")}
              placeholder="请填写样本姓名"
            />
          )
        },
      },
      {
        title: <div className="ta-c">样本备注</div>,
        dataInde: "remark",
        width: 70,
        render: (text, record) => {
          const { onInputChange } = this.props.pgdDataManageDetail
          return (
            <Observerremark
              record={record}
              onChange={(e) => onInputChange(e.target.value, record, "remark")}
              placeholder="请填写备注"
            />
          )
        },
      },
      {
        title: <div className="ta-c">关系</div>,
        width: 160,
        dataIndex: "relationName",
        render: (relationName, sample, index) => (
          <ObserverRelationSelector
            record={sample}
            relations={relations}
            onChange={(relationId) => onRelationChange(relationId, sample)}
          />
        ),
      },
      {
        title: <div className="ta-c">致病性</div>,
        width: 150,
        dataIndex: "pathogen",
        render: (relationName, sample, index) => (
          <ObserverPathogenSelector
            record={sample}
            onChange={(key) => onPathogenChange(key, sample)}
          />
        ),
      },
      {
        title: <div className="ta-r">数据大小</div>,
        dataIndex: "size",
        width: 70,
        render: (byteCount, record) => (
          <div className="ta-r">{disposeFileSize(byteCount)}</div>
        ),
      },
      {
        title: <div className="ta-c">上传日期</div>,
        dataIndex: "uploadTime",
        width: 80,
        sorter: (a, b) => new Date(a.uploadTime) - new Date(b.uploadTime),
        render: (text) => (
          <div style={{ whiteSpace: "pre-line" }} className="ta-c">
            {text.replace(" ", "\n")}
          </div>
        ),
      },
      {
        title: <div className="ta-c">Code</div>,
        dataIndex: "fileStatus",
        width: 90,
        render: (text) => (
          <div style={{ whiteSpace: "pre-line" }} className="ta-c">
            {text?text:'-'}
          </div>
        ),
      },
      {
        title: <div className="ta-c">操作</div>,
        dataIndex: "operator",
        width: 60,
        render: (text, record) => (
          <ObserverOperator record={record} onClick={this.showOperateModal} />
        ),
      },
    ]
    this.referenceColumns = [
      {
        title: <div className="ta-c">样本编号</div>,
        dataIndex: "number",
        width: 150,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">文库编号</div>,
        dataIndex: "libraryCode",
        width: 100,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">样本名称</div>,
        dataIndex: "sampleName",
        width: 100,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">亲缘关系</div>,
        dataIndex: "relationName",
        width: 100,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">样本类型</div>,
        dataIndex: "type",
        width: 100,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">核型</div>,
        dataIndex: "karyotype",
        width: 100,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">致病基因</div>,
        dataIndex: "pathogenicGenes",
        width: 100,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">突变类型</div>,
        dataIndex: "mutationType",
        width: 100,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">致病性</div>,
        dataIndex: "pathogenicityName",
        width: 100,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
      {
        title: <div className="ta-c">引物编号</div>,
        dataIndex: "primerNumber",
        width: 150,
        render: (text, record, index) => {
          return <div className="ta-c">{text}</div>
        },
      },
    ]

    this.referenceColumns.push({
      title: (
        <div className="ta-c">
          <Button
            className="synchronous-btn "
            size="small"
            type="primary"
            onClick={() => {
              this.handleSyncSampleInfo()
            }}
          >
            同步样本信息
          </Button>
        </div>
      ),
      dataIndex: "synchronous",
      width: 100,
    })

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    }

    return (
        <div>
          
          <div className=" wrapper-box ">
            <Row type="flex" justify="start" align="middle" className="subtitle">
              <i></i>
              <div>样本信息</div>

              {/* <Input
                type='textarea'
                ref={input => this.csvInput = input}
                style={{ width: 140, height: 28, resize: 'none'}}
                placeholder='请粘贴 csv 文本内容'
              />
              <Button
                type="primary"
                size="default"
                style={{marginLeft: 10}}
                onClick={this.parseCSV}>
                解析
              </Button> */}
            </Row>
            <Table
              className="datamanage-detail-table"
              columns={this.referenceColumns}
              rowKey={(record) => record.id}
              dataSource={samplesData.slice()}
              pagination={false}
              style={{ marginBottom: 20 }}
            />
            <div >
              <Row type="flex" justify='start' align='middle' className='subtitle'>
                <i></i>
                <div>数据列表</div>
                <div className="promotion">
                  注：在关系中显示同一颜色角色表示数据为同一人
                </div>
              </Row>
              <div className='form-bar form-bar-top'>
                <Row type="flex" justify='start' align='middle'>
                  <MaterialFormItem
                    labelWidth={60}
                    labelText="引物"
                    justify="center"
                  >
                    <Select
                      multiple
                      style={{ width: "260px" }}
                      placeholder="请输入并选择引物后运行"
                      totalPrimers={totalPrimers}
                      value={toJS(sampleData.primers)}
                      filterOption={(inputValue, option) => option.key.search(new RegExp(inputValue, "i")) > -1}
                      onChange={(primers) => onPrimerSelect(primers)}
                    >
                      {totalPrimers.slice().map(primer => <Option key={primer}>{primer}</Option>)}
                    </Select>
                  </MaterialFormItem>
                  <MaterialFormItem
                    labelWidth={60}
                    labelText="致病基因"
                    justify="center"
                  >
                    <Select
                      multiple
                      style={{ width: "260px" }}
                      placeholder="请选择致病基因后运行"
                      value={toJS(sampleData.genes)}
                      filterOption={(inputValue, option) => option.key.search(new RegExp(inputValue, "i")) > -1}
                      onChange={(genes) => onGenesSelect(genes)}
                    >
                      {totalGenes.slice().map((gene) => (
                        <Option key={gene}>{gene}</Option>
                      ))}
                    </Select>
                  </MaterialFormItem>
                  <MaterialFormItem
                    labelWidth={60}
                    labelText="男方突变"
                    justify="center"
                  >
                    <ObserverMutationsSelector
                      field='maleMutation'
                      // 过滤空值：排除 null、undefined、空字符串（根据需求调整）
                     value={(toJS(sampleData.maleMutation) || []).filter(item => 
                        item !== null && item !== undefined && item !== ''&& item !== " "&& item !== ""
                      )}
                    
                      totalMutations={totalMutations}
                      onChange={(maleMutation) => onMutationsSelect('maleMutation', maleMutation)}
                    />
                  </MaterialFormItem>
                  <MaterialFormItem
                    labelWidth={60}
                    labelText="女方突变"
                    justify="center"
                  >
                    <ObserverMutationsSelector
                      field='femaleMutation'
                       // 过滤空值：排除 null、undefined、空字符串（根据需求调整）
                     value={(toJS(sampleData.femaleMutation) || []).filter(item => 
                        item !== null && item !== undefined && item !== ''&& item !== " "&& item !== ""
                      )}
                      totalMutations={totalMutations}
                      onChange={(femaleMutation) => onMutationsSelect('femaleMutation', femaleMutation)}
                    />
                  </MaterialFormItem>
                </Row>
                {structureMut.map((traninfo, idx, arr) => {
                  return (
                    <Row type="flex" justify="center" key={idx}>
                      <Col span={4}>
                        <MaterialFormItem
                          labelWidth={50}
                          required={true}
                          labelText="结构变异"
                          justify="center"
                        >
                          <Select
                            style={{ width: '100px' }}
                            placeholder='请选择结构变异'
                            value={traninfo.type}
                            onChange={(type) => {
                              onTraninfoChange(traninfo, 'type', type, this)
                              handleTraninfoObj(traninfo, type)
                            }}
                          >
                            {TRANINFOS_OPTION.map(traninfo => (
                              <Option
                                key={traninfo.value}
                                value={traninfo.value}
                              >
                                {traninfo.label}
                              </Option>
                            ))}
                          </Select>
                          <OperateBtnWrapper>
                            {idx === arr.length - 1 ?
                              (<Icon
                                type="plus-circle"
                                onClick={() => this.operatorItem(idx, arr)}
                              />
                              ) :
                              (<Icon
                                type="minus-circle"
                                onClick={() => this.operatorItem(idx, arr)}
                              />
                              )}
                          </OperateBtnWrapper>
                        </MaterialFormItem>
                      </Col> 
                      <Col span={20}>
                        {React.cloneElement(TRANINFOS_MAP[traninfo.type], { traninfo, onTraninfoChange })}
                      </Col>
                    </Row>
                  )
                })}
                {delRange.map((traninfo, idx, arr) => {
                  return (
                    <Row type="flex" justify="center" key={idx}>
                      <Col span={4}>
                        <MaterialFormItem
                          labelWidth={50}
                          required={true}
                          labelText="缺失范围"
                          justify="center"
                        >
                          <Select
                            style={{ width: '100px' }}
                            placeholder='请选择缺失范围'
                            value={traninfo.gender}
                            onChange={(gender) => {
                              delRangeOnTraninfoChange(traninfo, 'gender', gender, this)
                            }}
                          >
                            {Range_OPTION.map(item => (
                              <Option
                                key={item.value}
                                value={item.value}
                              >
                                {item.label}
                              </Option>
                            ))}
                          </Select>
                            <OperateBtnWrapper>
                            {idx === arr.length - 1 ?
                              (<Icon
                                type="plus-circle"
                                onClick={() => this.delRangeOperatorItem(idx, arr)}
                              />
                              ) :
                              (<Icon
                                type="minus-circle"
                                onClick={() => this.delRangeOperatorItem(idx, arr)}
                              />
                              )}
                          </OperateBtnWrapper>
                        </MaterialFormItem>
                      </Col> 
                      <Col span={20}>
                        {React.cloneElement(TRANINFOS_MAP[traninfo.gender=='null'?'null':'Gender'], 
                        { traninfo, delRangeOnTraninfoChange })}
                      </Col>
                    </Row>
                  )
                })}
              </div>
            </div>
            <Table
              className="datamanage-detail-table"
              rowSelection={rowSelection}
              columns={this.columns}
              rowKey={(record) => record.id}
              dataSource={pgdDataDTOs}
              pagination={false}
            />
            <MaterialModal
              title="数据删除确认"
              className="upload-delete-modal"
              buttonType="danger"
              buttonText="删除"
              visible={this.state.showDeleteModal}
              action={() => this.deleteSample(focusedSample.id)}
            >
              <img
                className="pgx-modal-close"
                src={closeIcon}
                alt="关闭对话框"
                onClick={() => this.closeModal("showDeleteModal")}
              />
              <div className="sub-title">家系：{familyInfo.name}</div>
              <div className="description">{focusedSample.filename}</div>
              <div className="warning">
                <Icon type="exclamation-circle-o" />
                您确定要删除家系中的本条数据吗？
              </div>
            </MaterialModal>
            <EditModal
              visible={showEditModal}
              sample={focusedSample}
              onClose={() => this.closeModal("showEditModal")}
            // onConfirm={newName => {
            //   focusedSample.sampleName = newName
            //   focusedSample.hasHistory = true
            // }}
            />
          </div>
      </div>
    )
  }
}

@inject("pgdDataManageDetail")
@observer
class EditModal extends Component {
  @observable currentSampleName = ""
  @observable currentremark = ""

  componentWillReceiveProps(props) {
    this.currentSampleName = props.sample.sampleName
    this.currentremark = props.sample.remark
  }

  onSampleNameChange = (e) => {
    this.currentSampleName = e.target.value
  }

  onremarkChange = (e) => {
    this.currentremark = e.target.value
  }

  updateSample = () => {
    const {
      onClose,
      sample,
      pgdDataManageDetail: { updateSample },
    } = this.props

    if (!(this.currentSampleName || " ").trim()) {
      message.warning("样本名不能为空")
      return
    }

    updateSample(
      this.currentSampleName,
      this.currentremark,
      sample.dataId
    ).then(
      (res) => {
        sample.sampleName = this.currentSampleName // 因为 sample 是对 mobx 对象的一个引用
        sample.remark = this.currentremark // 因为 sample 是对 mobx 对象的一个引用
        sample.hasHistory = true // 因为 sample 是对 mobx 对象的一个引用
        sample.hasRemark = true // 因为 sample 是对 mobx 对象的一个引用
        sample.hasPatientName = true // 因为 sample 是对 mobx 对象的一个引用

        onClose()
        message.success("编辑保存成功")
      },
      (err) => {
        message.error(err.message)
      }
    )
  }

  render() {
    const { sample, visible, onClose } = this.props

    return (
      <MaterialModal
        title="数据编辑"
        buttonText="保存"
        className="pgd-datamanage-detail-modal"
        visible={visible}
        action={this.updateSample}
        buttonType="primary"
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <MaterialForm justify="center">
          <MaterialFormItem justify="center" labelText="文件名称">
            <FlexableFileName
              className="edit-filename"
              filename={sample.filename}
              matched={true}
            />
          </MaterialFormItem>
          <MaterialFormItem justify="center" labelText="样本名">
            <Input
              className="edit-samplename"
              value={this.currentSampleName}
              onChange={this.onSampleNameChange}
            />
          </MaterialFormItem>
          <MaterialFormItem justify="center" labelText="样本备注">
            <Input
              className="edit-samplename"
              value={this.currentremark}
              onChange={this.onremarkChange}
            />
          </MaterialFormItem>
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/data_manage_detail/containers/DataTable.js